import { render, staticRenderFns } from "./setUserConfiguration.vue?vue&type=template&id=77243e18&scoped=true&"
import script from "./setUserConfiguration.vue?vue&type=script&lang=js&"
export * from "./setUserConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77243e18",
  null
  
)

export default component.exports